import { createSignal } from "solid-js";

type Theme = "light" | "dark";

const localStorageKey = "theme";
let _theme: () => Theme;
let _setTheme: (v: Theme) => void;

function init() {
  let saved: Theme = "light";

  try {
    const raw = localStorage.getItem(localStorageKey);
    if (raw) saved = JSON.parse(raw) as Theme;
  } catch (e) {
    console.warn("Failed to read theme from localStorage", e);
  }

  const [theme, setThemeSignal] = createSignal<Theme>(saved);

  const setTheme = (v: Theme) => {
    setThemeSignal(v);

    try {
      localStorage.setItem(localStorageKey, JSON.stringify(v));
    } catch (e) {
      console.warn("Failed to write theme to localStorage", e);
    }

    // Pastikan body class sesuai
    if (document.body) {
      document.body.classList.remove("light", "dark");
      document.body.classList.add(v);
    }
  };

  _theme = theme;
  _setTheme = setTheme;

  // Tunggu DOM siap untuk set body class
  if (typeof window !== "undefined") {
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", () => setTheme(saved));
    } else {
      setTheme(saved);
    }
  }
}

// Initialize sekali
if (!_theme || !_setTheme) init();

/**
 * Refresh signal dari localStorage
 */
export function refreshThemeFromLocalStorage() {
  if (!_setTheme) return;
  try {
    const raw = localStorage.getItem(localStorageKey);
    if (raw) _setTheme(JSON.parse(raw) as Theme);
  } catch (e) {
    console.warn("Failed to refresh theme from localStorage", e);
  }
}

export function useTheme() {
  return [_theme, _setTheme] as const;
}
